import { MessageSquareText, Sparkles } from "lucide-react";

export function AssistantHeader({ focusAd }) {
  return (
    <header className="mb-4">
      <div className="text-xs font-mono uppercase tracking-wider text-blue-700">
        AI Assistant
      </div>
      <h1 className="font-display font-bold tracking-tight text-3xl">Ask MUKTI</h1>
      <p className="text-slate-500 text-sm mt-2 max-w-2xl">
        The assistant summarises evidence already in your database. It does not
        make legal judgements.
      </p>
      {focusAd && (
        <div
          data-testid="assistant-context-chip"
          className="mt-2 inline-flex items-center gap-1.5 text-xs bg-blue-50 text-blue-800 border border-blue-200 px-2 py-1 rounded-md font-mono"
        >
          <Sparkles className="h-3 w-3" /> Context: ad {focusAd.slice(0, 8)}
        </div>
      )}
    </header>
  );
}

export function EmptyState() {
  return (
    <div className="text-sm text-slate-500 flex items-center gap-2" data-testid="assistant-empty">
      <MessageSquareText className="h-4 w-4" />
      Ask anything about the collected advertisements.
    </div>
  );
}
